import { render } from "./DanhMucToaXeTable.vue?vue&type=template&id=a31fa376&ts=true"
import script from "./DanhMucToaXeTable.vue?vue&type=script&lang=ts"
export * from "./DanhMucToaXeTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__